export default __webpack_public_path__ + "static/media/arrow-turn-right-light-full.be146ce8.svg";